import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, Mail, MapPin, Building } from 'lucide-react';

const Impressum = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-emerald-50 via-teal-50 to-cyan-50">
      <div className="container mx-auto px-4 py-8 max-w-4xl">
        
        {/* Header */}
        <div className="mb-8">
          <Link to="/" className="inline-flex items-center text-emerald-600 hover:text-emerald-700 mb-4">
            <ArrowLeft className="w-4 h-4 mr-2" />
            Zurück zur Startseite
          </Link>
          <h1 className="text-4xl font-bold text-gray-900 mb-2">Impressum</h1>
          <p className="text-gray-600">Rechtliche Angaben gemäß § 5 TMG</p>
        </div>

        {/* Content */}
        <div className="bg-white rounded-lg shadow-lg p-8">
          
          <div className="grid md:grid-cols-2 gap-8">
            
            {/* Unternehmensinformationen */}
            <div>
              <h2 className="text-2xl font-semibold text-gray-900 mb-4 flex items-center">
                <Building className="w-6 h-6 mr-2 text-emerald-600" />
                Angaben zum Unternehmen
              </h2>
              
              <div className="space-y-4">
                <div>
                  <h3 className="font-semibold text-gray-800">Firmenname</h3>
                  <p className="text-gray-700">MYSYMP AG</p>
                </div>
                
                <div>
                  <h3 className="font-semibold text-gray-800 flex items-center">
                    <MapPin className="w-4 h-4 mr-1 text-emerald-600" />
                    Anschrift
                  </h3>
                  <p className="text-gray-700">
                    CH-6207 Nottwil<br />
                    Schweiz
                  </p>
                </div>
                
                <div>
                  <h3 className="font-semibold text-gray-800">Rechtsform</h3>
                  <p className="text-gray-700">Aktiengesellschaft (AG)</p>
                </div>
              </div>
            </div>
            
            {/* Kontaktinformationen */}
            <div>
              <h2 className="text-2xl font-semibold text-gray-900 mb-4 flex items-center">
                <Mail className="w-6 h-6 mr-2 text-emerald-600" />
                Kontakt
              </h2>
              
              <div className="space-y-4">
                <div>
                  <h3 className="font-semibold text-gray-800">E-Mail</h3>
                  <a href="mailto:info@interlingua.app" className="text-emerald-600 hover:text-emerald-700">
                    info@interlingua.app
                  </a>
                </div>
                
                <div>
                  <h3 className="font-semibold text-gray-800">Website</h3>
                  <a href="https://interlingua.app" className="text-emerald-600 hover:text-emerald-700">
                    https://interlingua.app
                  </a>
                </div>
              </div>
            </div>
          </div>
          
          <hr className="my-8" />
          
          {/* Produktinformationen */}
          <div className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">INTERLINGUA.APP</h2>
            <div className="bg-emerald-50 p-6 rounded-lg">
              <h3 className="font-semibold text-emerald-800 mb-2">INTERLINGUA.APP</h3>
              <p className="text-emerald-700 mb-4">
                Revolutionäre KI-gestützte Sprachlern-Plattform für modernes Sprachenlernen. 
                Intelligente AI-Lehrer, Spracherkennung und personalisierte Lernpfade. 
                Wissenschaftlich fundiert, praktisch anwendbar.
              </p>
              
              <h3 className="font-semibold text-emerald-800 mb-2">Die Plattform</h3>
              <p className="text-emerald-700">
                INTERLINGUA.APP ist eine innovative Sprachlern-Plattform mit personalisierten KI-Lehrern 
                für natürliches Sprachenlernen durch Konversation. Unterstützt Englisch, Französisch, 
                Spanisch und Italienisch mit intelligenter Aussprache-Korrektur und adaptive Lernalgorithmen.
              </p>
            </div>
          </div>
          
          {/* Rechtliche Hinweise */}
          <div className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">Rechtliche Hinweise</h2>
            
            <div className="space-y-6">
              <div>
                <h3 className="font-semibold text-gray-800 mb-2">Haftung für Inhalte</h3>
                <p className="text-gray-700 text-sm leading-relaxed">
                  Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene Inhalte auf diesen Seiten 
                  nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir als 
                  Diensteanbieter jedoch nicht unter der Verpflichtung, übermittelte oder gespeicherte 
                  fremde Informationen zu überwachen oder nach Umständen zu forschen, die auf eine 
                  rechtswidrige Tätigkeit hinweisen.
                </p>
              </div>
              
              <div>
                <h3 className="font-semibold text-gray-800 mb-2">Haftung für Links</h3>
                <p className="text-gray-700 text-sm leading-relaxed">
                  Unser Angebot enthält Links zu externen Websites Dritter, auf deren Inhalte wir 
                  keinen Einfluss haben. Deshalb können wir für diese fremden Inhalte auch keine 
                  Gewähr übernehmen. Für die Inhalte der verlinkten Seiten ist stets der jeweilige 
                  Anbieter oder Betreiber der Seiten verantwortlich.
                </p>
              </div>
              
              <div>
                <h3 className="font-semibold text-gray-800 mb-2">Urheberrecht</h3>
                <p className="text-gray-700 text-sm leading-relaxed">
                  Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten 
                  unterliegen dem schweizerischen Urheberrecht. Die Vervielfältigung, Bearbeitung, 
                  Verbreitung und jede Art der Verwertung außerhalb der Grenzen des Urheberrechtes 
                  bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers.
                </p>
              </div>
            </div>
          </div>
          
          {/* Alternative Streitbeilegung */}
          <div className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">Streitbeilegung</h2>
            <p className="text-gray-700 text-sm leading-relaxed">
              Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit: 
              <a href="https://ec.europa.eu/consumers/odr/" className="text-emerald-600 hover:text-emerald-700 ml-1" target="_blank" rel="noopener noreferrer">
                https://ec.europa.eu/consumers/odr/
              </a>
              <br />
              Unsere E-Mail-Adresse finden Sie oben im Impressum.
            </p>
          </div>
          
          <div className="border-t pt-6 text-sm text-gray-500">
            <p>Stand: {new Date().toLocaleDateString('de-DE')}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Impressum;